<template>
  <div>
    <div v-if="$mq.lg" @click="toggleSignInModal" class="cursor-pointer">
      <div v-if="$mq.md" class="text-center">
        <!-- <i class="far fa-user text-xl lg:text-3xl mb-1"></i> -->
        <button
          class="w-full bg-orange text-white rounded-lg mr-5 mb-4 xl:mr-0 text-10 xl:text-16 uppercase py-3 px-3 xl:px-10 focus:outline-none"
        >
          Sign In
        </button>
      </div>
      <div
        v-else
        class="font-bold text-black text-16 leading-1.2 py-24 uppercase"
      >
        Sign In
      </div>
    </div>

    <div v-else @click="toggleSignInModal">
      <button class="w-full py-18 bg-orange text-white rounded-lg uppercase">
        Sign In
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignInButton",

  methods: {
    async toggleSignInModal() {
      if (!this.$mq.lg) {
        await window.TheNavbarMobilePanel.close();
      }

      this.$root.$refs.signInModal.toggle();
    },
  },
};
</script>
